import type { FormatFnOptions } from "sql-formatter";

type FormatFn = (sql: string, options?: Partial<FormatFnOptions>) => string;

let formatSql: FormatFn | undefined;

// Eagerly start loading sql-formatter so it's ready by first use.
import("sql-formatter")
  .then((m) => {
    formatSql = m.format;
  })
  .catch((err) => {
    console.warn("Failed to load sql-formatter:", err);
  });

/**
 * Returns the lazily-loaded sql-formatter `format` function, or `undefined`
 * if it hasn't finished loading yet.
 */
export function getFormatSql(): FormatFn | undefined {
  return formatSql;
}
